import render from '@/filters/render'

export default {
  computed: {
    /**
     * Return our page meta, or try and find a nested page with meta.
     */
    metaData() {
      if (this.page.hasOwnProperty('meta')) {
        return this.page.meta
      }

      const objectWithMetaProp = Object.values(this.page).find(page =>
        page.hasOwnProperty('meta')
      )

      if (!objectWithMetaProp) return {}

      const { meta } = objectWithMetaProp

      return meta || {}
    },
  },

  head() {
    return {
      title: render(this.metaData?.title, this._self),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaData?.description,
        },
      ],
      link: this.$metaArray(),
    }
  },
}
